import React from 'react';
import { connect } from 'react-redux';
import styles from './side-bar.scss';
import PropTypes from 'prop-types';
import Legend from '../legend';
import * as selectors from '../../reducers';
import { setActiveProject } from '../../actions/index';
import { formatNumber } from '../../modules/bubbleHelper';
import StickyElement from '../sticky-element';
import Button from '../button';

const priorityNameMapper = {
  Customer: 'Customer Experience',
  DOI: 'Digital on the Inside',
  Data: 'Data',
};

class Sidebar extends React.Component {
  constructor() {
    super();
    this.closeSlidingBar = this.closeSlidingBar.bind(this);
  }

  closeSlidingBar() {
    this.props.setActiveProject(undefined);
  }

  renderSupportingClusters() {
    const { activeProject } = this.props;
    if (
      activeProject.clusters_other &&
      activeProject.clusters_other.length > 0
    ) {
      return (
        <div className={styles.slidingBarRow}>
          <span className={styles.slidingBarFieldName}>
            Supporting Clusters:{' '}
          </span>
          {activeProject.clusters_other.join(', ')}
        </div>
      );
    } else return null;
  }

  renderButton() {
    const { activeProject } = this.props;
    return activeProject.link ? (
      <Button
        big={true}
        link={activeProject.link}
        gaEvent={{
          event: 'Project learn more click',
          params: { event_label: activeProject.name },
        }}
      />
    ) : null;
  }

  renderContent() {
    const { activeProject } = this.props;
    if (activeProject) {
      return (
        <div className={styles.slidingBarInner}>
          <h1>{activeProject.name}</h1>
          <div className={styles.slidingBarRow}>
            <span className={styles.slidingBarFieldName}>Cluster: </span>
            {activeProject.cluster}
          </div>
          <div className={styles.slidingBarRow}>
            <span className={styles.slidingBarFieldName}>Agency: </span>
            {activeProject.agency}
          </div>
          <div className={styles.slidingBarRow}>
            <span className={styles.slidingBarFieldName}>Budget: </span>
            {formatNumber(activeProject.budget)}
          </div>
          <div className={styles.slidingBarRow}>
            <span className={styles.slidingBarFieldName}>Priority: </span>
            {priorityNameMapper[activeProject.priority]}
          </div>

          {this.renderSupportingClusters()}

          <div className={styles.slidingBarRowDescription}>
            <div className={styles.slidingBarFieldName}>
              Project Description:{' '}
            </div>
            <p className={styles.slidingBarTextDescription}>
              {activeProject.description}
            </p>
          </div>
          {this.renderButton()}
        </div>
      );
    } else return null;
  }

  render() {
    const { activeProject } = this.props;
    return (
      <div className={styles.sidebar}>
        <StickyElement>
          <Legend />
        </StickyElement>
        <div
          className={`${styles.slidingBar} ${activeProject
            ? styles.slidingBarActive
            : ''}`}
        >
          <div>
            <button
              type={'button'}
              className={styles.slidingBarCloseButton}
              onClick={this.closeSlidingBar}
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/times-white.svg`}
                alt="close button"
              />
            </button>
            <StickyElement>{this.renderContent()}</StickyElement>
          </div>
          <div />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeProject: selectors.getActiveProject(state),
  activeTab: selectors.getActiveTab(state),
});

const mapDispatchToProps = {
  setActiveProject,
};

Sidebar.propTypes = {
  activeProject: PropTypes.object,
  activeTab: PropTypes.string,
  setActiveProject: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/side-bar/side-bar.js